var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('avatar-form',{attrs:{"size":80,"profile":_vm.business,"loading":_vm.submitting,"color":"accent"},on:{"change":_vm.updateImage}})}
var staticRenderFns = []

export { render, staticRenderFns }